<template lang="pug">
#drawer-inspecionar-camadas
    el-drawer.font-component(
        :title="$t('mensagens.menuSig.inspecionarCamadas')",
        direction='rtl',
        :class='menuMaior ? "drawer-inspecionar-camadas" : "drawer-inspecionar-camadas menor"',
        :visible.sync='show',
        :before-close='fechar',
        :wrapperClosable='false',
        :modal='false',
        :lock-scroll='true',
        :append-to-body='false',
        :close-on-press-escape='true',
        :size='menuMaior ? 360 : 247',
        :show-close='true'
    )
        span.ml-3 {{ municipioEstado }}

        Diagnostico(:dadosConsulta='resultados', :inspecionar='true')
</template>

<script>
import Diagnostico from '@/components/diagnosticoSocioambiental/index';
import { CamadasService } from '@/services/CamadasService.js';

export default {
    name: 'DrawerInspecionarCamadas',

    emits: ['fechar'],

    components: {
        Diagnostico
    },

    props: {
        show: {
            type: Boolean,
            required: false,
            default: false
        },
        geometria: {
            type: Object,
            required: true
        },
        menuMaior: {
            type: Boolean,
            required: false,
            default: false
        },
        camadas: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            resultados: {},
            estado: undefined,
            municipio: undefined,
            car: undefined
        };
    },

    computed: {
        municipioEstado() {
            let municipioEstado = '';

            if (this.municipio && this.municipio.resultados[0]) {
                municipioEstado = this.municipio.resultados[0].properties.nome;

                if (this.estado && this.estado.resultados[0]) {
                    municipioEstado += ` - ${this.estado.resultados[0].properties.sigla}`;
                }
            } else if (this.estado && this.estado.resultados[0]) {
                municipioEstado = this.estado.resultados[0].properties.nome;
            }

            return municipioEstado;
        },

        codigoCar() {
            let car = '';

            if (this.car && this.car.resultados[0]) {
                car = `CAR: ${this.car.resultados[0].properties.codigo}`;
            }

            return car;
        }
    },

    watch: {
        show: function () {
            if (this.show) {
                this.inspecionarCamadas();
            }
        }
    },

    methods: {
        fechar() {
            this.$emit('fechar');
        },

        inspecionarCamadas() {
            CamadasService.inspecionarCamadas(
                this.camadas,
                JSON.stringify(this.geometria)
            )
                .then(({ data }) => {
                    this.resultados = {
                        diagnosticos: data.filter(({ camada }) => {
                            return (camada.codigo);
                        })
                    };
                    this.estado = data.filter(
                        ({ camada }) => camada.codigo === 'BR_LOCALIDADE_NIVEL_1'
                    )[0];
                    this.municipio = data.filter(
                        ({ camada }) => camada.codigo === 'BR_LOCALIDADE_NIVEL_2'
                    )[0];
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.menuSig.errorDrawerCamadas')
                    });
                });
        }
    }
};
</script>

<style lang="scss">
#drawer-inspecionar-camadas {
    font-family: 'Roboto', 'sans serif';
    .el-drawer.rtl {
        border-radius: 0 3px 3px 0;
    }

    .drawer-inspecionar-camadas {
        position: absolute;

        .el-input--prefix .el-input__inner {
            padding-left: 35px;
        }

        #el-drawer__title > button > i {
            &::before {
                color: #3b3b3b;
                font-weight: 600;
                font-size: 16px;
            }
        }

        #el-drawer__title
            > div.w-100.el-input.el-input--prefix
            > .el-input__prefix {
            top: 10px;
            left: 10px;
            color: var(--primary) !important;
            i {
                font-size: 20px;
            }
        }

        #el-drawer__title
            > div.w-100.el-input.el-input--suffix
            > .el-input__suffix {
            color: var(--primary) !important;
            i {
                font-size: 20px;
            }
        }
    }

    .drawer-inspecionar-camadas.menor {
        .el-input--prefix .el-input__inner {
            padding-left: 35px;
        }

        #el-drawer__title > button > i {
            &::before {
                color: #3b3b3b;
                font-weight: 600;
                font-size: 14px;
            }
        }

        #el-drawer__title > div.w-100.el-input.el-input--prefix > span {
            top: 10px;
            left: 10px;
            color: var(--primary) !important;
            i {
                font-size: 20px;
            }
        }

        #el-drawer__title
            > div.w-100.el-input.el-input--suffix
            > .el-input__suffix {
            color: var(--primary) !important;
            i {
                font-size: 20px;
            }
        }
    }
}
.el-drawer__body {
    @include scroll-bar();
}

.font-component {
    font-size: 18px;
}
</style>
